import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { EnvProvider } from '../../context/env';
import { ExperimentProvider } from '../../context/experiment';

//TODO: Move more of the base level contexts into this provider. Location / Router / etc
export const DiscoverProviders: React.FunctionComponent = (props: $FixMe) => {
    return (
        <EnvProvider
            env={props.env}
            gaSettings={props.gaSettings}
            request={props.request}
            user={props.user}
            app_version={props.app_version}
            app_name={props.app_name}
            isBotRequest={props.isBotRequest}
        >
            <ExperimentProvider>{props.children}</ExperimentProvider>
        </EnvProvider>
    );
};
